
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/order`;

export const orderService = {

    getOrderList: async function (strartDate:Date,endDate:Date,type:string) {
        return axios.get(`${GATEWAY_URL}/list`, {
            params: {
                startDate: strartDate,
                endDate: endDate,
                type:type
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetailList: async function (orderId:number) {
        return axios.get(`${GATEWAY_URL}/lines`, {
            params: {
                orderId: orderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetail: async function (orderId:number) {
        return axios.get(`${GATEWAY_URL}/get`, {
            params: {
                orderId: orderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },
    getOrdersDelete: async function () {
        return axios.get(`${GATEWAY_URL}/orders_delete`, {})
            .then((response) => {return response.data;});
    },
    
}
